module.exports = __webpack_public_path__ + "static/sport/loading.19f6dad.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/loading.gif
// module id = StBO
// module chunks = 0